import { useFlags } from "launchdarkly-react-client-sdk";

import { type Noun, noun } from "src/utils/noun";

// With the AMP rollout a configured report is called a routine. What a run generates is still a report, and code and URLs keep saying report.
const REPORT = noun("report", "reports");
const ROUTINE = noun("routine", "routines");

/** The user-facing name for a configured report under the current flags. */
export const useReportTerm = (): Noun => {
  const { appAmpV2 } = useFlags();
  return appAmpV2 ? ROUTINE : REPORT;
};
